import {Replay} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useTranslation} from "react-i18next";
import brokenLamp from '../../../assets/images/broken-lamp.png'
import Grid from "@mui/material/Grid";
import {Helmet} from "react-helmet";

const SomethingWentWrong = () => {
    const {t} = useTranslation()

    const handleRefreshPage = () => {
        window.location.reload()
    }

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>
            <Grid container height="100%" textAlign="center" alignItems="center" gap="0.5em" justifyContent="center"
                  flexDirection="column" flexGrow={1}>
                <img alt="Broken lamp" src={brokenLamp} height={50}/>
                <Box>
                    <Typography variant="h5" color="primary"
                                fontWeight="bold">{t("something_went_wrong")}...</Typography>
                    <Typography variant="body1" color="primary">{t("working_on_fixing_problem")}.</Typography>
                </Box>
                <Button startIcon={<Replay/>} variant="outlined"
                        onClick={handleRefreshPage}>{t("refresh_page")}</Button>
            </Grid>
        </>
    )
}

export default SomethingWentWrong
